import React from 'react';
import type { FC } from 'react';
import isUnicodeSupported from 'is-unicode-supported';
import { Text } from '../components/Text.js';

interface Props {
  appearance?: 'chevron' | 'triangle' | 'exclamation';
}

export const PointerIcon: FC<Props> = ({ appearance }) => {
  switch (appearance) {
    case 'exclamation':
      return <Text>!</Text>;
    case 'triangle':
      return <Text>{isUnicodeSupported() ? '▶' : '>'}</Text>;
    default:
      return <Text>{isUnicodeSupported() ? '❯' : '>'}</Text>;
  }
};
